module.exports = __webpack_public_path__ + "img/dataIntegrity.56ec86ee.png";